import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { teamByIdQueryDocument } from "./team.gql";

export interface UseGetTeamProps {
  id?: string;
  enabled?: boolean;
}

export const useGetTeam = ({ enabled = true, ...props }: UseGetTeamProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.teams.detail(props.id ?? ""),
    queryFn: async () => {
      if (!props.id) {
        throw new Error("Team ID is required");
      }
      const client = createOperationClient("teamById");
      const data = await client.request(teamByIdQueryDocument, { input: props.id });
      return data.teamById;
    },
    enabled: enabled && !!props.id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const team = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    team,
    loading: queryResult.isLoading,
    error: queryResult.error,
    queryResult,
  };
};
